import styled from 'styled-components';

export const StyledPre = styled.pre`
  display: flex;
  overflow: auto hidden;
  padding: ${(p) => p.theme.space[3]};
  line-height: ${(p) => p.theme.space[4]};

  &:not(:first-child) {
    margin-top: ${(p) => p.theme.space[3]};
  }
`;
